module.exports = __webpack_public_path__ + "static/media/graphism-left-grayscale.250bd030.svg";